module.exports = __webpack_public_path__ + "img/icon3.c68a1ac0.jpg";